export default {"src":"/_next/static/media/zhong.12b7b004.svg","height":100,"width":250,"blurWidth":0,"blurHeight":0};